import React from "react";
import { Box, Stack, Typography, Avatar } from "@mui/material";
import { ReactComponent as Desktop } from "../../../assets/images/ChatImages/laptop.svg";
import { ReactComponent as Mobile } from "../../../assets/images/mobile-devices.svg";
import { ReactComponent as DoubleGreentick } from "../../../assets/images/ChatImages/doubleTick.svg";
import { ReactComponent as DoubleGreytick } from "../../../assets/images/ChatImages/doubleGreyTick.svg";
import { colorCodesForAvatar } from "../../../constants/index";
import { chracterPosition } from "../../../utils/index";
import { visitorAppearsOnline } from "../../../utils/index";
import { formatCv2ListTime } from "../../../utils/chatV2Helpers";
import "./chatListRowV2.css";

export { formatCv2ListTime };

function ChatListRowV2({
  item,
  isActive,
  showTyping,
  style,
  onClick,
}) {
  const title = item?.title || "Visitor";
  const initial = title.charAt(0).toUpperCase();
  const online = visitorAppearsOnline(item);
  const unread = Number(item?.num) || 0;
  const osLabel = item?.os || item?.device || "Unknown";
  const isDesktop = item?.deviceType === "desktop";
  const timeLabel = formatCv2ListTime(item?.time, item?.iso);
  // Same rules as ChatMessageComponent: green when latest agent msg is read.
  // Closed/archived list rows never show read-receipt ticks.
  const readReceipt =
    !showTyping &&
    unread === 0 &&
    !item?.is_archived &&
    !item?.end_session
      ? item?.readReceipt || null
      : null;

  return (
    <div style={style} className="cv2-list-row-outer">
      <button
        type="button"
        className={`cv2-list-row${isActive ? " cv2-list-row--active" : ""}${
          item?.end_session ? " cv2-list-row--ended" : ""
        }`}
        onClick={onClick}
      >
        <Box className="cv2-list-row__avatar">
          {item?.img ? (
            <Avatar
              variant="circular"
              src={item.img}
              alt=""
              sx={{ width: 32, height: 32 }}
            />
          ) : (
            <Avatar
              variant="circular"
              sx={{
                width: 32,
                height: 32,
                fontSize: 14,
                fontWeight: 500,
                bgcolor: colorCodesForAvatar[chracterPosition(initial)],
              }}
            >
              {initial}
            </Avatar>
          )}
          <span
            className={`cv2-list-row__status ${online ? "is-online" : "is-offline"}`}
            aria-hidden
            style={{ right: '3px', bottom:'2px'}}
          />
        </Box>

        <Box sx={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: "8px" }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 500,
                color: item?.end_session ? "#405261" : "#061522",
                lineHeight: "18px",
                textTransform: "capitalize",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flex: 1,
                minWidth: 0,
                textAlign: "left",
              }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 400,
                color: "#061522",
                lineHeight: "18px",
                flexShrink: 0,
                whiteSpace: "nowrap",
              }}
            >
              {timeLabel}
            </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: showTyping || unread ? 500 : 400,
                color: showTyping ? "#389E0D" : unread ? "#061522" : "#405261",
                lineHeight: "18px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flex: 1,
                minWidth: 0,
                textAlign: "left",
              }}
            >
              {showTyping
                ? "Typing ..."
                : item?.attachment
                  ? "Sent Attachment"
                  : item?.description || ""}
            </Typography>
            {unread > 0 ? (
              <span className="cv2-list-row__unread">{unread > 99 ? "99+" : unread}</span>
            ) : readReceipt === "read" ? (
              <span className="cv2-list-row__tick" aria-label="Read">
                <DoubleGreentick />
              </span>
            ) : readReceipt === "sent" ? (
              <span className="cv2-list-row__tick" aria-label="Sent">
                <DoubleGreytick />
              </span>
            ) : null}
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
            <Stack direction="row" alignItems="center" gap={0.5} sx={{ minWidth: 0 }}>
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "& svg": { width: 16, height: 16 },
                }}
              >
                {isDesktop ? <Desktop /> : <Mobile />}
              </Box>
              <Typography
                sx={{
                  fontSize: 12,
                  color: "#405261",
                  lineHeight: "12px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {osLabel}
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </button>
    </div>
  );
}

export default ChatListRowV2;
